import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Separate axios instance for students (uses X-Student-Authorization header)
export const studentApi = axios.create({ baseURL: API, withCredentials: true });
studentApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("vk_student_token");
  if (t) config.headers["X-Student-Authorization"] = `Bearer ${t}`;
  return config;
});

const Ctx = createContext(null);

export function StudentAuthProvider({ children }) {
  const [student, setStudent] = useState(null); // null=loading, false=unauth, obj=logged in
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await studentApi.get("/students/me");
        setStudent(data);
      } catch {
        setStudent(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (phone, password) => {
    const { data } = await studentApi.post("/students/login", { phone, password });
    if (data?.token) localStorage.setItem("vk_student_token", data.token);
    setStudent(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await studentApi.post("/students/register", payload);
    if (data?.token) localStorage.setItem("vk_student_token", data.token);
    setStudent(data);
    return data;
  };

  const logout = async () => {
    try { await studentApi.post("/students/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("vk_student_token");
    setStudent(false);
  };

  return (
    <Ctx.Provider value={{ student, ready, login, register, logout }}>
      {children}
    </Ctx.Provider>
  );
}

export const useStudentAuth = () => useContext(Ctx);
